import { Messages } from '../../../../codegen/Localize';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { ISetPermissionsAction } from '../../../../ts/ServerApi/types/actionNames';
import { setContentPermissions } from '../../../actions/spaces/SetContentPermissionsActions';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { isSingleEmbeddedDatasource } from './IEntityActionHelpers';

export const SetPermissionsAction: IEntityAction<IContentInfo, ISetPermissionsAction> = {
  name: EntityActionNames.Permissions,
  translateName: Messages.permissions_action,
  isVisible: (targetItems: IContentInfo[]) => {
    return !isSingleEmbeddedDatasource(targetItems);
  },
  isClickable: (availableActions: ISetPermissionsAction) => !!(availableActions && availableActions.setPermissions),
  createReduxAction: (targetItems: IContentInfo[]) => setContentPermissions(targetItems)
};
